module.exports = __webpack_public_path__ + "static/img/yun01_2.21127ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_2.jpg
// module id = 0Ci5
// module chunks = 1